// API Configuration
//export const API_BASE_URL = 'https://dev.digitalservices.crs/rfccommentsapi';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
export const API_KEY = process.env.REACT_APP_API_KEY || '';
export const API_HEADER_NAME = process.env.REACT_APP_API_HEADER_NAME || 'x-fcl-rest';

export const API_ENDPOINTS = {
  COMMENTS: `${API_BASE_URL}/comments`,
  COMMENTS_COUNT: `${API_BASE_URL}/comments/count`,
  // New endpoint for fetching all comments by Period and RA (without COA filter)
  ALL_COMMENTS: `${API_BASE_URL}/comments/all`,
};

export const COLORS = {
  PRIMARY_RED: '#CC0000',
  HOVER_RED: '#A30000',
};

export const FIELD_LIMITS = {
  USERNAME: 60,
  LINE_ITEM: 60,
  COMMENT: 1000,
};

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('API Base URL:', API_BASE_URL);
  console.log('API Header Name:', API_HEADER_NAME);
  console.log('API Key:', API_KEY ? 'Configured ✓' : 'Missing ✗');
}
